'use client';

import React, { useRef, useState, useEffect } from 'react';
import { Star, MapPin, Car, Users } from 'lucide-react';

const STATS = [
  { icon: Car, value: '10,000+', label: 'Trips Completed', color: 'text-primary' },
  { icon: MapPin, value: '50+', label: 'Destinations Covered', color: 'text-secondary' },
  { icon: Star, value: '4.8★', label: 'Average Rating', color: 'text-accent' },
  { icon: Users, value: '8,500+', label: 'Happy Customers', color: 'text-primary' },
];

export default function StatsStrip() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-white border-b border-border shadow-sm">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 py-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {STATS?.map((stat, i) => (
            <div
              key={`stat-${stat?.label}`}
              className={`flex items-center gap-4 transition-all duration-500 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="w-12 h-12 bg-primary-light rounded-xl flex items-center justify-center flex-shrink-0">
                <stat.icon size={22} className={stat?.color} />
              </div>
              <div>
                <div className={`text-2xl font-extrabold font-tabular ${stat?.color}`}>
                  {stat?.value}
                </div>
                <div className="text-sm text-muted-foreground font-medium">{stat?.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}